import React from "react";
import { motion } from "framer-motion";

const scrollReveal = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.2 } },
};

const WhyChooseUs = () => {
    const cardData = [
        {
            title: "Customer Acquisition",
            description:
                "They proactively identify and reach out to individuals or businesses who need loans.",
            icon: "fa-user-plus",
        },
        {
            title: "Product Promotion",
            description:
                "They market various loan products, such as home loans, personal loans, and business loans, to potential borrowers.",
            icon: "fa-bullhorn",
        },
        {
            title: "Loan Process Facilitation",
            description:
                "They guide customers through the entire loan application process, explaining loan options, eligibility criteria, and interest rates.",
            icon: "fa-hand-holding-usd",
        },
        {
            title: "Documentation and Verification",
            description:
                "They assist in collecting and submitting required documents and conduct basic due diligence to ensure the information is genuine.",
            icon: "fa-file-alt",
        },
        {
            title: "Bridging the Gap",
            description:
                "They bridge the gap between the borrower and the lending institution, simplifying the process for both parties.",
            icon: "fa-people-arrows",
        },
        {
            title: "Benefits for Lenders",
            description:
                "DSAs help financial institutions expand their customer base, increase sales, and efficiently manage the loan pipeline.",
            icon: "fa-university",
        },
        {
            title: "Benefits for Borrowers",
            description:
                "They offer a convenient and personalized experience, helping borrowers find the best loan options tailored to their needs and navigate the application process smoothly.",
            icon: "fa-users",
        },
        {
            title: "Benefits for DSA Agents",
            description:
                "Agents earn a commission for each successful loan application, creating an opportunity for income generation.",
            icon: "fa-briefcase",
        },
    ];


    return (
        <motion.div
            className="wcu-main-smco"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
        >
            <motion.h2 className="sections-title-smco" variants={scrollReveal}>
                <span className="horizontal-line"></span>Why Choose Us
            </motion.h2>
            <motion.p className="sections-description-smco" variants={scrollReveal}>
                Key Functions of a Loan DSA Company
            </motion.p>

            <motion.div className="wcu-container-smco" variants={staggerContainer}>
                <motion.div className="wcu-grid-smco" variants={staggerContainer}>
                    {cardData.map((item, index) => (
                        <motion.div key={index} className="wcu-card-smco" variants={scrollReveal}>
                            {/* Semi-circle Background */}
                            <motion.div className="wcu-semicircle-smco" variants={scrollReveal}></motion.div>

                            {/* Icon using <i> tag */}
                            <motion.div className="wcu-icon-container-smco" variants={scrollReveal}>
                                <i className={`fa ${item.icon} wcu-icon-smco`}></i>
                            </motion.div>

                            {/* Title */}
                            <motion.h3 className="wcu-title-smco" variants={scrollReveal}>{item.title}</motion.h3>

                            {/* Description */}
                            <motion.p className="wcu-description-smco" variants={scrollReveal}>{item.description}</motion.p>
                        </motion.div>
                    ))}
                </motion.div>
            </motion.div>
        </motion.div>
    );
};

export default WhyChooseUs;
